import Dialog from "./Dialog";


export default function ComponentsOverrides(theme) {
    return Object.assign(
        Dialog(theme)
    );
}
